// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2Blz1","amount":"Amount_amount__27lVc","tip":"Amount_tip__1Dqmc","tipHeader":"Amount_tipHeader__bYHu6","tipsWrap":"Amount_tipsWrap__2AxJ9"};